export default __webpack_public_path__ + "static/media/up.2f5bcf58.svg";